import { SchoolService, BaseService } from "@/services/school.service";

const TaskService = {
    getTaskGroups() {
        return SchoolService.getAll("taskgroups")
    },

    getTasksByGroup(groupId) {
        return SchoolService.getAll("taskgroups/" + groupId + "/tasks")
    },

    // GRADES
    getResultsByGroup(groupId) {
        return SchoolService.getAll("taskgroups/" + groupId + "/results")
    },

    addResult(payload) {
    	return SchoolService.create("taskresults", payload)
    },

    deleteResult(result) {
    	return SchoolService.delete("taskresults", result.identifier, null)
    },
     
}

export { TaskService };